import { FloatElement } from '../../components/float-element/float-element'

export class HotspotsFloatElement extends FloatElement {}
